$(document).on('mouseenter', '.pub__shoppable-image__dot', function() {
    // Get the aria-labelledby attribute of the hovered element
    var ariaLabelledby = $(this).attr('aria-labelledby');
    
    // Find the parent ul and remove the active class from all areas
    var $parentUl = $(this).closest('ul.pub__shoppable-image__product-list');
    $parentUl.find('.pub__shoppable-image__area').removeClass('pub__shoppable-image__area--active');
    
    // Add the active class to the parent .pub__shoppable-image__area of the hovered element
    $(this).closest('.pub__shoppable-image__area').addClass('pub__shoppable-image__area--active');
});
$(document).ready(function() {
    // Open the mega-menu flyout for a given parent card and position it.
    function mrkOpenDropdown($item) {
        $('.mrk-parent-item').removeClass('mrk-active-dropdown');
        $item.addClass('mrk-active-dropdown');
        var contentId = $item.attr('data-content');
        // Hide all dropdowns, then reveal the one for this card.
        $('.mrk-menu-dropdown-item').hide();
        $('#' + contentId).show();
        $('.hnf-dropdown').addClass('hnf-list-box--open');
        $('.mrk-main-menu-wrapper').addClass('hnf-carousel--dropdown-open');
        var mrk_offset = (window.innerWidth - 1200) / 2;
        var leftPos = $item.offset().left - mrk_offset;
        var total_left = leftPos + $('.hnf-dropdown').width();
        if (total_left > window.innerWidth) {
            leftPos = window.innerWidth - mrk_offset - $('.hnf-dropdown').width() - 60;
        }
        $('.hnf-dropdown').css('--hnf-dropdown-left', leftPos + 'px');
    }
    function mrkCloseDropdown() {
        $('.hnf-dropdown').removeClass('hnf-list-box--open');
        $('.mrk-main-menu-wrapper').removeClass('hnf-carousel--dropdown-open');
        $('.mrk-parent-item').removeClass('mrk-active-dropdown');
    }

    // Open the flyout on HOVER (not click), so a plain click follows the card's
    // own href ({{ link.url }}) straight to the collection — the same target as
    // the "Explore <category>" link inside the flyout.
    $(document).on('mouseenter', '.mrk-parent-item', function() {
        mrkOpenDropdown($(this));
    });
    // The cards and the flyout both live inside .hnf-tabs-navigation__container,
    // so moving between them keeps it open; leaving the whole region closes it.
    $(document).on('mouseleave', '.hnf-tabs-navigation__container', function() {
        mrkCloseDropdown();
    });

    // Safety: also close when clicking anywhere outside the menu region.
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.hnf-dropdown').length && !$(event.target).closest('.hnf-carousel-slide').length) {
            mrkCloseDropdown();
        }
    });
    // Gallery Tabs (.tab-btn-item / .mrk-load-more) are handled by the inline
    // script in sections/gallary-tabs.liquid since 23 Aug 2026 — the jQuery
    // handlers that used to live here double-bound the buttons and appended a
    // cached copy of the same galleries on "Load More" (duplicate images).

    function updateScrollButtons(scrollBar, carousel) {
        var scrollLeft = scrollBar.scrollLeft();
        var scrollWidth = scrollBar[0].scrollWidth;
        var clientWidth = scrollBar[0].clientWidth;

        // Hide the previous button if we're at the start
        if (scrollLeft <= 0) {
            carousel.find('.mrk-prev-btn').addClass('hnf-carousel__button--hidden');
        } else {
            carousel.find('.mrk-prev-btn').removeClass('hnf-carousel__button--hidden');
        }

        // Hide the next button if we're at the end
        if (scrollLeft + clientWidth >= scrollWidth) {
            carousel.find('.mrk-next-btn').addClass('hnf-carousel__button--hidden');
        } else {
            carousel.find('.mrk-next-btn').removeClass('hnf-carousel__button--hidden');
        }
    }

    function checkIfScrollable(scrollBar, carousel) {
        var scrollWidth = scrollBar[0].scrollWidth;
        var clientWidth = scrollBar[0].clientWidth + 20;
        console.log(scrollWidth,clientWidth);
        // If the content doesn't overflow, add the mrk-no-scrolling class
        if (scrollWidth <= clientWidth) {
            carousel.addClass('mrk-no-scrolling');
        } else {
            carousel.removeClass('mrk-no-scrolling');
        }
    }

    // Handle click on the previous button
    $('.mrk-prev-btn').on('click', function(e) {
        e.preventDefault();

        // Find the parent .hnf-carousel and the .mrk-scroll-bar within it
        var carousel = $(this).closest('.hnf-carousel');
        var scrollBar = carousel.find('.mrk-scroll-bar');

        // Scroll left by a defined amount (e.g., 400px)
        var scrollAmount = 400;
        scrollBar.animate({
            scrollLeft: '-=' + scrollAmount
        }, 400, function() {
            // Update buttons after the scroll completes
            updateScrollButtons(scrollBar, carousel);
        });
    });

    // Handle click on the next button
    $('.mrk-next-btn').on('click', function(e) {
        e.preventDefault();

        // Find the parent .hnf-carousel and the .mrk-scroll-bar within it
        var carousel = $(this).closest('.hnf-carousel');
        var scrollBar = carousel.find('.mrk-scroll-bar');

        // Scroll right by a defined amount (e.g., 400px)
        var scrollAmount = 400;
        scrollBar.animate({
            scrollLeft: '+=' + scrollAmount
        }, 400, function() {
            // Update buttons after the scroll completes
            updateScrollButtons(scrollBar, carousel);
        });
    });

    // On page load, check if scrolling is possible and update the buttons
    $('.hnf-carousel').each(function() {
        var carousel = $(this);
        var scrollBar = carousel.find('.mrk-scroll-bar');

        // Check if scroll is possible and update the buttons and class
        checkIfScrollable(scrollBar, carousel);
        updateScrollButtons(scrollBar, carousel);
    });
});
